import React from "react";
import { SectionTitle } from "components/items";
import makeTitle from "function/makeTitle.js";
import fac_image_01 from "image/factory/factoryList-01.png";
import fac_image_02 from "image/factory/factoryList-02.png";
import fac_image_03 from "image/factory/factoryList-03.png";
import fac_image_04 from "image/factory/factoryList-04.png";

const sectionTitle = [
	{
		text: "SOLID",
		color: "defualt",
		break: false,
	},
	{
		text: "FACTORY",
		color: "main",
		break: true,
	},
];

const factoryList = [
	{
		id: 1,
		title: "OEM/ODM",
		text: "동구밭 팩토리의 체계화된 품질관리와 다년 간의 연구개발로 만들어진 기술력으로 고객의 니즈에 맞는 상품을 생산합니다.",
		image: fac_image_01,
	},
	{
		id: 2,
		title: "호텔어메니티",
		text: "지속가능성을 강조한 프리미엄 고체어메니티 상품을 제조 납품합니다.",
		image: fac_image_02,
	},
	{
		id: 3,
		title: "기업행사/답례품",
		text: "기업의 행사 기념품, 명절 선물과 답례품으로 동구밭 제품을 납품하고 있습니다.",
		image: fac_image_03,
	},
	{
		id: 4,
		title: "자사제품 제조판매",
		text: "동구밭의 가치를 담아 합리적이고, 기능성이 강조된 헤어/바디/페이스/베이비/리빙/D.I.Y 라인의 제품을 제조하여 자사 온라인몰에서 판매하고 있습니다.",
		image: fac_image_04,
	},
];

const SolidFactory = (props) => {
	return (
		<section className={`SolidFactory ${props.className}`}>
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="center" />
					<p className="section-text center">
						동구밭 팩토리에서는 발달장애인이 비장애인과 함께 일하며 월 40만여개의 최고 품질 고체화장품을 생산할 수 있는 고체화장품 전문 제조 공장입니다. CP(Cold process) 비누, 약산성 비누, 설거지비누,
						샴푸바, 린스바, 입욕제 등 플라스틱과 보존제, 화학성분을 사용하지 않는 자연유래 성분의 친환경 제품 생산에 최적화 되어 있습니다. 또한 모든 공정은 발달장애인 사원도 일할 수 있도록 안전하고
						정확한 절차를 지키도록 설계되어 있습니다.
					</p>
				</div>
			</div>
			<div className="section-contents">
				<div className="con">
					<ul className="wrap-facList">
						{factoryList.map((el) => {
							const bgStyle = {
								backgroundImage: `url(${el.image})`,
							};
							return (
								<li key={el.id}>
									<div className="bgImage" style={bgStyle}></div>
									<div className="dim"></div>
									<div className="wrap-text">
										<h5>{el.title}</h5>
										<p>{el.text}</p>
									</div>
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		</section>
	);
};

export default SolidFactory;
